var shouldDelayInitialPillTransition = layData.navigation_transition_use_revealing_transition_on_first_visit == 'on'
var initialPillTransitionReady = !shouldDelayInitialPillTransition
var initialPillTransitionFallback = null
var initialPillTransitionRelease = null

function enableInitialPillTransition() {
	if (initialPillTransitionReady || initialPillTransitionRelease) {
		return
	}
	if (initialPillTransitionFallback) {
		clearTimeout(initialPillTransitionFallback)
		initialPillTransitionFallback = null
	}
	initialPillTransitionRelease = setTimeout(function () {
		initialPillTransitionReady = true
		initialPillTransitionRelease = null
		window.requestAnimationFrame(function () {
			window.requestAnimationFrame(function () {
				jQuery('.nav-pill[data-lay-pill-positioned="true"]').addClass('nav-pill-transition')
			})
		})
	}, 750)
}

if (shouldDelayInitialPillTransition) {
	window.laytheme.on('transition_navigation_in_completed', enableInitialPillTransition)
	initialPillTransitionFallback = setTimeout(enableInitialPillTransition, 5000)
}

var getPillMenuAvailableWidth = function (nav) {
	var viewportWidth = document.documentElement.clientWidth
	var computedStyle = window.getComputedStyle(nav)
	var sideOffset = 0
	var isLeftPosition = nav.classList.contains('laynav-position-top-left') ||
		nav.classList.contains('laynav-position-center-left') ||
		nav.classList.contains('laynav-position-bottom-left') ||
		nav.classList.contains('mobile-menu-position-left') ||
		nav.classList.contains('mobile-menu-position-bottom-left')
	var isRightPosition = nav.classList.contains('laynav-position-top-right') ||
		nav.classList.contains('laynav-position-center-right') ||
		nav.classList.contains('laynav-position-bottom-right') ||
		nav.classList.contains('mobile-menu-position-right') ||
		nav.classList.contains('mobile-menu-position-bottom-right')

	if (isLeftPosition) {
		sideOffset = parseFloat(computedStyle.left) || 0
	} else if (isRightPosition) {
		sideOffset = parseFloat(computedStyle.right) || 0
	}

	// Keep the active left/right spacing on both viewport edges once the menu is capped.
	return Math.max(0, viewportWidth - Math.max(0, sideOffset) * 2)
}

var updatePillMenuOverflow = function (nav) {
	// A scrolling nav clips overflowing dropdowns, so keep submenu-based pill menus unchanged.
	var isHorizontal = nav.classList.contains('arrangement-horizontal') || nav.classList.contains('mobile-menu-style-pill_menu_style')
	if (!isHorizontal || jQuery(nav).children('ul').children('.menu-item-has-children').length > 0) {
		nav.removeAttribute('data-lay-pill-scrollable')
		nav.style.removeProperty('--lay-pill-menu-max-width')
		nav.style.removeProperty('--lay-pill-menu-end-spacing')
		nav.setAttribute('data-lay-pill-overflow-ready', 'true')
		return
	}

	nav.removeAttribute('data-lay-pill-scrollable')
	nav.style.removeProperty('--lay-pill-menu-max-width')
	nav.style.removeProperty('--lay-pill-menu-end-spacing')

	var availableWidth = getPillMenuAvailableWidth(nav)
	var naturalWidth = nav.getBoundingClientRect().width
	if (naturalWidth > availableWidth + 1) {
		nav.style.setProperty('--lay-pill-menu-max-width', Math.floor(availableWidth) + 'px')
		// right padding isn't part of the scrollable area of overflowing flex content,
		// so CSS adds an end spacer of this width (see menustyle_pill.scss)
		var endSpacing = parseFloat(window.getComputedStyle(nav).paddingRight) || 0
		nav.style.setProperty('--lay-pill-menu-end-spacing', endSpacing + 'px')
		nav.setAttribute('data-lay-pill-scrollable', 'true')
	}
	nav.setAttribute('data-lay-pill-overflow-ready', 'true')
}

var scrollPillMenuToCurrent = function (nav, current, navpadding, animate, pillpadding) {
	if (nav.getAttribute('data-lay-pill-scrollable') !== 'true') {
		return
	}
	// include the pill padding so the whole pill stays visible, not just the menu item
	pillpadding = pillpadding || 0

	var navrect = nav.getBoundingClientRect()
	var currentrect = current.getBoundingClientRect()
	var visibleLeft = navrect.left + navpadding
	var visibleRight = navrect.right - navpadding
	var visibleWidth = visibleRight - visibleLeft
	var targetLeft = null

	if (currentrect.width + pillpadding * 2 > visibleWidth || currentrect.left - pillpadding < visibleLeft) {
		targetLeft = nav.scrollLeft + currentrect.left - pillpadding - visibleLeft
	} else if (currentrect.right + pillpadding > visibleRight) {
		targetLeft = nav.scrollLeft + currentrect.right + pillpadding - visibleRight
	}

	if (targetLeft === null) {
		return
	}

	if (typeof nav.scrollTo === 'function') {
		nav.scrollTo({
			left: targetLeft,
			behavior: animate ? 'smooth' : 'auto',
		})
	} else {
		nav.scrollLeft = targetLeft
	}
}

// Function to position the pill
function positionPill() {
	jQuery('.nav-style-pill').each(function () {
		var direction = jQuery(this).hasClass('arrangement-vertical') ? 'vertical' : 'horizontal'
		var $nav = jQuery(this).closest('.laynav')
		if (this.getAttribute('data-lay-pill-overflow-ready') !== 'true') {
			updatePillMenuOverflow(this)
		}
		var navrect = this.getBoundingClientRect()
		var $pill = jQuery(this).find('.nav-pill')
		var hasPositionedPill = $pill.attr('data-lay-pill-positioned') === 'true'

		var $current = jQuery(this).find('.lay-anchor-menu-item.current-menu-item')
		if($current.length == 0) {
			$current = jQuery(this).find('.current-menu-item')
		}
		if($current.length == 0) {
			$pill.addClass('nav-opacity-pill-transition');
			$pill.removeClass('nav-pill-transition');
			$pill.removeAttr('data-lay-pill-positioned');
			$pill.css({
				opacity: 0,
			})
			return;
		}
		var currentrect = $current[0].getBoundingClientRect()

		var current_w = currentrect.width
		var current_top = currentrect.top
		var current_left = currentrect.left

		// Get padding values from CSS
		var navpadding = parseInt(jQuery(this).css('padding'))
		var pillpadding = parseInt(jQuery(this).find('.nav-pill').css('padding'))
		// opacity transition
		$pill.addClass('nav-opacity-pill-transition');
		if (hasPositionedPill && initialPillTransitionReady) {
			$pill.addClass('nav-pill-transition');
			$pill[0].offsetWidth;
		} else {
			$pill.removeClass('nav-pill-transition');
		}

		if(direction == 'horizontal') {
			var current_target_top = current_top - navrect.top - pillpadding - navpadding
			var current_target_left = current_left - navrect.left - pillpadding - navpadding + $nav[0].scrollLeft
			var pill_h = $nav[0].getBoundingClientRect().height - navpadding * 2

			$pill.css({
				transform: 'translate(' + current_target_left + 'px, ' + current_target_top + 'px)',
				width: current_w,
				opacity: 1,
				height: pill_h + 'px',
			})
		} else {
			// vertical
			var current_target_top = current_top - navrect.top - pillpadding - navpadding
			var current_target_left = current_left - navrect.left - pillpadding - navpadding
			var pill_h = currentrect.height

			$pill.css({
				transform: 'translate(' + current_target_left + 'px, ' + current_target_top + 'px)',
				width: current_w,
				opacity: 1,
				height: pill_h + 'px',
			})
		}

		$pill.attr('data-lay-pill-positioned', 'true');
		if (direction == 'horizontal') {
			scrollPillMenuToCurrent($nav[0], $current[0], navpadding, hasPositionedPill && initialPillTransitionReady, pillpadding)
		}
		if (!hasPositionedPill && initialPillTransitionReady) {
			window.requestAnimationFrame(function () {
				if ($pill.attr('data-lay-pill-positioned') === 'true') {
					$pill.addClass('nav-pill-transition');
				}
			})
		}

	})
}

// Wait for webfonts to load before first positioning
if (document.fonts && document.fonts.ready) {
	document.fonts.ready.then(function() {
		// Do initial positioning after fonts are loaded
		positionPill();
	});
} else {
	// Fallback for browsers that don't support document.fonts
	setTimeout(function() {
		positionPill();
	}, 100);
}

window.laytheme.on('current-menu-point-activated', function () {
	positionPill();
})

var breakpointAbove = window.innerWidth >= parseInt(layData.phone_menu_breakpoint, 10);
var lastBreakpointAbove = breakpointAbove;

jQuery(window).on('window_width_changed', function () {
	jQuery('.nav-pill').removeClass('nav-pill-transition');
	jQuery('.nav-pill').removeAttr('data-lay-pill-positioned');
	jQuery('.nav-style-pill').each(function () {
		this.removeAttribute('data-lay-pill-overflow-ready')
		updatePillMenuOverflow(this)
	})

	setTimeout(function() {
		positionPill();
	}, 0);
})

jQuery(window).on('lay_pill_menu_position_changed', function () {
	jQuery('.nav-style-pill').each(function () {
		this.removeAttribute('data-lay-pill-overflow-ready')
		updatePillMenuOverflow(this)
	})
	positionPill()
})

// Desktop mice only scroll vertically. Translate the wheel into horizontal
// scrolling when the pointer is over a scrollable pill menu, otherwise the
// menu is unreachable without a trackpad. Lenis smooth-scroll would capture
// the wheel otherwise (it preventDefaults before native scrolling happens).
var onPillMenuWheel = function (event) {
	if (event.ctrlKey) {
		return
	}
	// the horizontal scroll layout owns wheel events while active
	var html = document.documentElement
	if (html && (html.classList.contains('horizontal-scroll-active') || html.getAttribute('data-horizontal-scroll-active') === '1')) {
		return
	}
	var target = event.target
	if (!target || typeof target.closest !== 'function') {
		return
	}
	var nav = target.closest('[data-lay-pill-scrollable="true"]')
	if (!nav) {
		return
	}
	var delta = Math.abs(event.deltaX) > Math.abs(event.deltaY) ? event.deltaX : event.deltaY
	if (delta === 0) {
		return
	}
	if (event.deltaMode === 1) {
		// lines (Firefox mouse wheel) -> pixels
		delta *= 32
	} else if (event.deltaMode === 2) {
		// pages
		delta *= nav.clientWidth
	}
	var maxScrollLeft = Math.max(0, nav.scrollWidth - nav.clientWidth)
	var canScroll = delta > 0 ? nav.scrollLeft < maxScrollLeft - 1 : nav.scrollLeft > 1
	if (!canScroll) {
		// menu is at its end: let the event through so the page keeps scrolling
		return
	}
	nav.scrollLeft += delta
	event.preventDefault()
	event.stopPropagation()
	// Lenis checks this flag and leaves the event alone
	event.lenisStopPropagation = true
}

window.addEventListener('wheel', onPillMenuWheel, { passive: false, capture: true })

export { scrollPillMenuToCurrent, updatePillMenuOverflow }
